var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M707.544 497.911L586.764 515.495L618.87 353.034L707.544 343.478V497.911Z",
    fill: "#067799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.037 134L288.633 167.639L281.753 244.091L471.334 465.801V174.519L396.037 134Z",
    fill: "#067799"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M917 351.505L672.763 450.893L684.611 375.97L891.391 191.721L917 351.505Z",
    fill: "#067799"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83 648.521L118.164 583.919L413.619 558.308L492.738 596.151L108.609 733L83 648.521Z",
    fill: "#057696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M707.544 497.911L586.764 515.495L618.87 353.034L707.544 343.478V497.911Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.037 134L288.633 167.639L281.753 244.091L471.334 465.801V174.519L396.037 134Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M917 351.505L672.763 450.893L684.611 375.97L891.391 191.721L917 351.505Z",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83 648.521L118.164 583.919L413.619 558.308L492.738 596.151L108.609 733L83 648.521Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL5);
export default __webpack_public_path__ + "static/media/l5.57e18cf4b4090da9a3216d0a7e2b0f7d.svg";
export { ForwardRef as ReactComponent };